import type { ReactNode } from 'react';
import { OverlayProvider } from 'react-aria';
import { BrowserRouter as Router } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { QueryClientProvider } from '@tanstack/react-query';
import Toaster from '~components/common/Toaster';
import { ThemingProvider } from '~services/theming';
import { I18nProvider } from '~services/i18n';
import { queryClient } from '~services/queryClient';
import { AuthProvider } from '~services/auth';
import { SidebarProvider } from '~contexts/SidebarContext';
import { OptionsProvider } from '~contexts/OptionsContext';
import { LastModifiedProvider } from '~contexts/LastModifiedContext';
import { DeviceStateProvider } from '~contexts/DeviceStateContext';

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <OptionsProvider>
        <LastModifiedProvider>
          <DeviceStateProvider>
            <SidebarProvider>
              <ThemingProvider>
                <AuthProvider>
                  <I18nProvider>
                    <OverlayProvider>
                      <DndProvider backend={HTML5Backend}>
                        <Router>{children}</Router>
                      </DndProvider>
                    </OverlayProvider>
                    <Toaster />
                  </I18nProvider>
                </AuthProvider>
              </ThemingProvider>
            </SidebarProvider>
          </DeviceStateProvider>
        </LastModifiedProvider>
      </OptionsProvider>
    </QueryClientProvider>
  );
}
